const IBGE_MUNICIPIOS_URL =
  'https://servicodados.ibge.gov.br/api/v1/localidades/estados';

export async function fetchCitiesByUf(uf: string): Promise<string[]> {
  const sigla = uf.trim().toUpperCase();
  if (sigla.length !== 2) return [];

  const response = await fetch(`${IBGE_MUNICIPIOS_URL}/${sigla}/municipios?orderBy=nome`);
  if (!response.ok) {
    throw new Error('Não foi possível carregar as cidades.');
  }

  const data: { nome: string }[] = await response.json();
  return data.map((m) => m.nome);
}

export function normalizeCityName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function findCityInList(cityName: string, cities: string[]): string | null {
  const normalized = normalizeCityName(cityName);
  return cities.find((c) => normalizeCityName(c) === normalized) ?? null;
}

export function ensureCityInOptions(cityName: string, cities: string[]): string[] {
  if (!cityName.trim()) return cities;
  const match = findCityInList(cityName, cities);
  if (match) return cities;
  return [cityName.trim(), ...cities];
}
